export const ScoreStatusConstants = {
  APPROVED: '11af04cd-622e-4c16-983c-173eff666ab3',
  ACKNOWLEDGED: '0c410175-ce4f-433f-aebf-1f2ec2128646',
  PENDING_UPDATED: 'a46e69f6-5278-41e3-b7c6-3a7a2e02a528',
  APPROVED_WITH_FEEDBACK: 'a129c5be-24a4-4c0c-b8e3-3d2cb8880c5e',
  PENDING: '1748598e-274a-4374-a88f-412fc2414762',
  OUTSTANDING: '94a28c53-9674-4d33-81f0-528faac8c0d5',
  REVIEWED_WITH_FEEDBACK: 'c4ccd753-50d8-4476-a35d-5ab3de5853b5',
  DECLINED: '82c85936-dd88-4e98-8b69-dc8260e4f425',
};
